import styled from 'styled-components'
import { motion } from 'framer-motion'
import { colors, getFontStyle } from '@diversioteam/diversio-ds'

import type { LoadMoreCardContainerProps, LoadMoreIconProps } from './LoadMoreNotificationCard.types'

export const LoadMoreCardContainer = styled(motion.div)<LoadMoreCardContainerProps>`
    position: sticky;
    bottom: 0;
    padding: 4px 20px;
    cursor: ${(props) => (props.$isLoading ? 'default' : 'pointer')};
    transition: all 0.2s ease;
    border-top: 1px solid ${colors.primaryGray2};
    background: ${colors.primaryWhite};
    display: flex;
    align-items: center;
    gap: 0.75rem;
    justify-content: center;
    z-index: 10;

    &:hover {
        background: ${(props) => (props.$isLoading ? colors.primaryWhite : colors.primaryGray1)};
    }

    &:active {
        background: ${(props) => (props.$isLoading ? colors.primaryWhite : colors.primaryGray2)};
    }

    ${(props) =>
        props.$isLoading &&
        `
        opacity: 0.7;
    `}
`

export const LoadMoreIcon = styled(motion.div)<LoadMoreIconProps>`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.primary60};

    ${(props) =>
        props.$isLoading &&
        `
        color: ${colors.primary40};
    `}
`

export const LoadMoreContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    flex: 1;
    text-align: center;
`

export const LoadMoreTitle = styled.div`
    ${getFontStyle('p03Medium')}
    color: ${colors.primary80};
    display: flex;
    align-items: center;
    gap: 0.5rem;
`

export const LoadMoreDescription = styled.div`
    ${getFontStyle('p03Regular')}
    color: ${colors.primary60};
`

export const LoadMoreSpinner = styled(motion.div)`
    width: 16px;
    height: 16px;
    border: 2px solid ${colors.primaryGray2};
    border-top-color: ${colors.primary60};
    border-radius: 50%;
`
